import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DemoAccountModal } from '@/components/portal/DemoAccountModal'

export function DemoAccountPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/dashboard?demo=1', { replace: true })
  }, [navigate])

  return <DemoAccountModal open onClose={() => navigate('/dashboard')} />
}
